// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1fdqJ","badges":"styles_badges__3OrkJ"};